export default {
  title: 'Are you sure?',
  description: 'Following modifier groups (including their modifiers as well) will be deleted:',
  buttons: {
    yes: 'Yes',
    no: 'No',
  },
  toasts: {
    modifier_group_got_deleted: 'Modifier groups got deleted',
    failed_to_delete_modifier_group: 'Failed to delete the modifier group',
  },
};
